<template>
<div id="page-templates" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Avisos y Video Tutoriales" class="elevation-1 px-5 py-3" >
                    <v-card-actions>

                        <v-spacer></v-spacer>

                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="500px" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >{{ update ? "edit" : "add" }}
                                        </v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>{{ update ? "Actualizar" : "Nuevo" }} Aviso</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>

                                <v-card-text>
                                    <v-form ref="form" lazy-validation>
                                        <v-container grid-list-md>
                                            <v-layout wrap>
                                                 <v-flex xs12>
                                                    <v-text-field label="Categoría" v-model="model.categoria" :rules="[rules.required]" ></v-text-field>
                                                </v-flex>
                                                 <v-flex xs12>
                                                    <v-text-field label="Nombre" v-model="model.nombre" :rules="[rules.required]" ></v-text-field>
                                                </v-flex>
                                                 <v-flex xs12>
                                                    <v-text-field label="Contenido" v-model="model.texto" :rules="[rules.required]" ></v-text-field>
                                                </v-flex>
                                             
                                                <v-flex xs12>
                                                    <v-select :items="tipos" v-model="model.tipo" label="Video Tutorial" item-text="texto" item-value="key" single-line :rules="[rules.required]" ></v-select>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <v-select :items="estatus" v-model="model.activo" label="Estatus" item-text="texto" item-value="key" single-line :rules="[rules.required]" ></v-select>
                                                </v-flex>

                                            </v-layout>
                                        </v-container>
                                    </v-form>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>

                                    

                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" @click.native="update ? updateAviso() : saveAviso()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>
                                 <template slot="tipo" slot-scope="props" >
                                    <span v-if="props.row.tipo == 1" >Inicio de Sesión</span>
                                    <span v-else>Video Tutorial</span>
                                </template> 
                                 
                                <template slot="activo" slot-scope="props" >
                                    <span v-if="props.row.activo == 1" >Activo</span>
                                    <span v-else>Desactivado</span>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="getAviso(props.row)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="deleteAviso(props.row.id_notificaciones_marquee)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {
    created: function () {
        this.getAvisos();
    },
    data() {
        return {
            fab: false,
            estatus: [{
                key: 1,
                texto: 'Activo'
            }, {
                key: 2,
                texto: 'Desactivado'
            }],
            tipos: [{
                key: 1,
                texto: 'Inicio Sesión'
            }, {
                key: 2,
                texto: 'Video Tutorial'
            }],
            items: [],
            name: "datagrid",
            columns: [
                "categoria",
                "nombre",
                "texto",
                "tipo",
                "activo",
                "actions"
            ],
            show_loading: true,
            options: {
                filterable: ["texto"],
                sortable: ["texto"],

                headings: {
                    categoria: "Categoría",
                    nombre: "Título del Tema-Video",
                    texto: "Vínculo de Enlace a Video",
                    tipo: "Ubicación",
                    activo: "Estatus",
                    actions: "Operaciones"
                }
            },
            show_loading: true,
            breadcrumbs: [{
                    text: "Administración",
                    disabled: false,
                    to: "/admin"
                },
                {
                    text: "Avisos y Video Tutoriales",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            update: false,
            estados: [],
            model: {
                texto: "",
                activo: ""
            },
            rules: {
                required: v => !!v || "Este campo es requerido",
            },

        };
    },

    methods: {
        openModal: function (type) {
            if (type === 1) {
                this.model.activo = 1;
                this.limpiarModel();
                this.update = false;
            } else
                this.update = true;

            this.modal = true;
        },
        limpiarModel: function () {
            for (var k in this.model)
                this.model[k] = "";
        },
        getAvisos: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.$hostname + "catalogos/notificaciones_marquee/", {
                    'cliente': this.model.cliente
                })
                .then(response => {
                    this.items = response.data;
                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {
                  
                    this.$root.$dialogLoader.hide();
                });
        },
        saveAviso: function () {
            if (this.$refs.form.validate()) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                axios
                    .post(this.$hostname + "catalogos/notificaciones_marquee/", this.model, {
                        "Content-Type": "multipart/form-data",
                        "Access-Control-Allow-Origin": "*",
                        "cache-control": "no-cache"
                    })
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El aviso se creo correctamente.",
                            footer: ""
                        });

                        this.modal = false;
                        this.$root.$dialogLoader.hide();
                        this.getAvisos();
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un erro al crear el aviso",
                            footer: ""
                        });
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        getAviso: function (row) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.model.texto = row.texto;
            this.model.activo = row.activo;
            this.model.tipo = row.tipo;
            this.model.nombre = row.nombre;
            this.model.categoria = row.categoria;
            this.model.id_notificaciones_marquee = row.id_notificaciones_marquee;

            this.$root.$dialogLoader.hide();
            this.openModal(2);
        },
        updateAviso: function () {
            let id_notificaciones_marquee = this.model.id_notificaciones_marquee;

            if (this.$refs.form.validate()) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                axios
                    .put(this.$hostname + "catalogos/notificaciones_marquee/" + id_notificaciones_marquee + "/", this.model)
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El aviso se actualizó correctamente.",
                            footer: ""
                        });

                        this.$root.$dialogLoader.hide();
                        this.getAvisos();
                        this.modal = false;
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al actualizar el aviso",
                            footer: ""
                        });
                    });
            }
        },
        deleteAviso: function (id_notificaciones_marquee) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                        .delete(this.$hostname + "catalogos/notificaciones_marquee/" + id_notificaciones_marquee + "/")
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El aviso se eliminó correctamente.",
                                footer: ""
                            });
                            this.$root.$dialogLoader.hide();
                            this.getAvisos();
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar un aviso",
                                footer: ""
                            });
                        });
                }
            });
        }
    }
};
</script>